function initializeFinancingAccordion(scope = document) {
  const financingRoots = scope.matches?.(".financing-options")
    ? [scope]
    : Array.from(scope.querySelectorAll(".financing-options"));

  financingRoots.forEach((root) => {
    if (root.dataset.financingAccordionInitialized === "true") return;

    const titleElement = root.querySelector(".financing-options-title");
    const box = root.querySelector(".financing-options-box");
    const arrowBtn = root.querySelector(".financing-options-title svg");
    const accordionActive = root.querySelector(".accordion-active");

    if (!titleElement || !box || !arrowBtn) return;

    root.dataset.financingAccordionInitialized = "true";

    const setBoxMaxHeight = () => {
      if (!box.classList.contains("open")) return;
      box.style.maxHeight = `${box.scrollHeight + 200}px`;
    };

    const ensureFinancingContentMounted = () => {
      const financingMain = root.querySelector(".financing-options-main");
      if (!financingMain) return;

      const mountedFinanceOptions = financingMain.querySelector(".finance-main-options");
      if (!mountedFinanceOptions) {
        const sourceFinanceOptions = Array.from(document.querySelectorAll(".finance-main-options"))
          .find((element) => !root.contains(element));

        if (sourceFinanceOptions) {
          financingMain.appendChild(sourceFinanceOptions);
        }
      }

      if (financingMain.querySelector(".tabs-container")) {
        initializeMainTab(document);
        initializeTab(document);
        initializeTabTexts(document);
        initializeScroll(document);
        initializeFinancePartnerSlider(document);
      }
    };

    const openBox = () => {
      ensureFinancingContentMounted();
      box.classList.add("open");
      arrowBtn.classList.add("open");
      requestAnimationFrame(setBoxMaxHeight);
    };

    const closeBox = () => {
      box.style.maxHeight = `${box.scrollHeight}px`;
      requestAnimationFrame(() => {
        box.classList.remove("open");
        arrowBtn.classList.remove("open");
        box.style.maxHeight = "0px";
      });
    };

    if (accordionActive) {
      openBox();
    }

    titleElement.addEventListener("click", () => {
      if (box.classList.contains("open")) {
        closeBox();
      } else {
        openBox();
      }
    });

    window.addEventListener("resize", setBoxMaxHeight);

    const boxObserver = new MutationObserver(() => {
      setBoxMaxHeight();
    });

    boxObserver.observe(box, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
    });
  });
}

const dom = {
  querySelector: (selector, parent = document) => parent.querySelector(selector),
  querySelectorAll: (selector, parent = document) => parent.querySelectorAll(selector),
  createElement: (tag) => document.createElement(tag),
  addEventListener: (element, event, handler) => element?.addEventListener(event, handler),
};

const outputFormatter = new Intl.NumberFormat("es-CO", {
  style: "decimal",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  useGrouping: true,
});

const parsePrice = (priceString) => {
  if (!priceString) return 0;
  const price = Number(priceString.replace(/,/g, ""));
  return price;
};

function hasFinancingElements() {
  return Boolean(document.querySelector(".financing-options"))
    && Boolean(document.querySelector(".finance-main-options"));
}

function hasCartFinanceElements() {
  return Boolean(document.querySelector('.cart-payment-blocks__button[data-modal-target="modal-net-monthly-pricing-modal"], .cart-payment-blocks__link[data-modal-target="modal-net-monthly-pricing-modal"]'))
    && Boolean(document.querySelector(".finance-options-modal-overlay"))
    && Boolean(document.querySelector(".finance-options-modal-content"))
    && Boolean(document.querySelector(".financing-options-main .finance-options-modal-template"));
}

function bootstrapCartFinancePopup() {
  if (!hasCartFinanceElements()) return;
  if (document.body?.dataset?.cartFinanceInitialized === "true") return;
  initializeFinanceOptionsPopup();
  document.body.dataset.cartFinanceInitialized = "true";
}

function bootstrapFinancingApp() {
  if (!hasFinancingElements()) return;
  initializeApp();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrapFinancingApp);
  document.addEventListener("DOMContentLoaded", bootstrapCartFinancePopup);
} else {
  bootstrapFinancingApp();
  bootstrapCartFinancePopup();
}

const financingObserver = new MutationObserver(() => {
  if (!hasFinancingElements()) return;
  bootstrapFinancingApp();
  financingObserver.disconnect();
});

const cartFinancingObserver = new MutationObserver(() => {
  if (!hasCartFinanceElements()) return;
  bootstrapCartFinancePopup();
  cartFinancingObserver.disconnect();
});

if (document.body) {
  financingObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
  cartFinancingObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function initializeApp() {
  if (!hasFinancingElements()) return;
  if (document.body?.dataset?.financingInitialized === "true") return;

  initializeFinancingAccordion(document);
  moveFinanceMainOptions();
  createFinanceModalTemplate();
  initializeMainTab(document);
  initializeTab(document);
  initializeTabTexts(document);
  initializeFinanceOptionsPopup();
  initializeScroll(document);
  initializeFinancePartnerSlider(document);
  initializePriceObserver();
  initializeSortOrderObserver();
  readMoreListener();

  document.body.dataset.financingInitialized = "true";
}
function initializeMainTab(dom) {
  const mainTabBlocks = dom.querySelectorAll(".tabs-container-block");
  const tabTitles = dom.querySelectorAll(".tab--title");
  const tabDescriptions = dom.querySelectorAll(".tab--description");

  function updateTabsBasedOnActive() {
    const activeMainTab = dom.querySelector(".tabs-container-block.tabs-container-active");
    const financeTitle = dom.querySelector(".financing-options-title-cash");
    const activeIndex = [...mainTabBlocks].indexOf(activeMainTab);
    const activeClass = `finance-option-${activeIndex + 1}`;

    if (financeTitle) {
      financeTitle.textContent = activeMainTab.textContent
    }

    tabTitles.forEach(title => {
      title.style.display = title.classList.contains(activeClass) ? "block" : "none";
    });

    tabDescriptions.forEach(desc => {
      desc.style.display = desc.classList.contains(activeClass) ? "block" : "none";
    });

    dom.querySelectorAll('.tab--title').forEach(el => el.classList.remove('tab--active'));
    const firstVisibleTab = dom.querySelector(`.tab--title.${activeClass}`);
    if (firstVisibleTab) firstVisibleTab.classList.add('tab--active');

    const firstVisibleDesc = dom.querySelector(`.tab--description.${activeClass}`);
    tabDescriptions.forEach(desc => desc.style.display = "none");
    if (firstVisibleDesc) firstVisibleDesc.style.display = "block";
  }
  mainTabBlocks.forEach((mainTabBlock) => {
    mainTabBlock.addEventListener("click", () => {
      mainTabBlocks.forEach(block => block.classList.remove("tabs-container-active"));
      mainTabBlock.classList.add("tabs-container-active");

      updateTabsBasedOnActive();
    });
  });

  updateTabsBasedOnActive();
}

function initializePriceObserver() {
  const optionsContainer = document.querySelector(".options_description-container");
  if (!optionsContainer) return;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "data-product-actual-price") {
        const tabTexts = document.querySelectorAll(".tab-text");
        const { symbol: currencySymbol = "$", code: currencyCode = "COP" } = optionsContainer.dataset;
        const newPrice = optionsContainer.dataset.productActualPrice;

        tabTexts.forEach((tabText) => {
          recalculateInstallments(tabText, currencySymbol, currencyCode, newPrice);
        });
      }
    });
  });

  observer.observe(optionsContainer, { attributes: true });
}

function initializeSortOrderObserver() {
  const tabTexts = document.querySelectorAll(".tab-text");
  if (tabTexts.length === 0) return;

  const optionsContainer = document.querySelector(".options_description-container");
  if (!optionsContainer) return;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "data-sort-order") {
        const tabText = mutation.target;
        const { symbol: currencySymbol = "$", code: currencyCode = "COP", productActualPrice = "0" } = optionsContainer.dataset;
        processTabText(tabText, currencySymbol, currencyCode, productActualPrice);
      }
    });
  });

  tabTexts.forEach((tabText) => {
    observer.observe(tabText, { attributes: true, attributeFilter: ["data-sort-order"] });
  });
}

function recalculateInstallments(tabText, currencySymbol, currencyCode, newPrice) {
  const buttonsContainer = tabText.querySelector(".installments-buttons-inline");
  const selectedDisplay = tabText.querySelector(".selected-option-display");
  const descriptionWrapper = tabText.querySelector(".description-wrapper");
  const finalPriceBlock = tabText.querySelector(".final-price-block");
  const container = document.querySelector(".options_description-container");

  if (!buttonsContainer || !selectedDisplay || !descriptionWrapper || !finalPriceBlock) return;

  const formattedProductPrice = container?.dataset?.productPrice || "$0 COP";

  const totalPrice = parsePrice(newPrice);

  const tempDiv = createTempDiv(tabText.getAttribute("data-description"));
  updateProductPrice(tempDiv, formattedProductPrice);

  const installementsData = tabText.getAttribute("data-installments") || "1";
  if (installementsData) {
    const installmentsNumbers = JSON.parse(installementsData);
    const activeButton = buttonsContainer.querySelector(".installment-btn.active") || buttonsContainer.querySelector(".installment-btn");
    if (!activeButton) return;

    const selectedMonth = activeButton.dataset.month || installmentsNumbers[0];
    const selectedMonthNumber = Number(selectedMonth);
    const selectedPriceNumber = outputFormatter.format(totalPrice / selectedMonthNumber);

    updateInstallmentInfo(
      selectedDisplay,
      descriptionWrapper,
      tempDiv,
      selectedPriceNumber,
      selectedMonthNumber,
      selectedMonth,
      currencySymbol,
      currencyCode,
      finalPriceBlock,
    );
  }
}

function moveFinanceMainOptions() {
  const financingOptionsBox = dom.querySelector(".financing-options-main");
  const financeMainOptions = dom.querySelector(".finance-main-options");
  if (financingOptionsBox && financeMainOptions) {
    financingOptionsBox.appendChild(financeMainOptions);
  }
}

function createFinanceModalTemplate() {
  const financingOptionsMain = dom.querySelector(".financing-options-main");
  if (!financingOptionsMain) return;
  if (financingOptionsMain.querySelector(".finance-options-modal-template")) return;

  const financeMainOptions = financingOptionsMain.querySelector(".finance-main-options");
  if (!financeMainOptions) return;

  const template = document.createElement("template");
  template.classList.add("finance-options-modal-template");
  template.innerHTML = financeMainOptions.outerHTML;
  financingOptionsMain.appendChild(template);
}

function initializeTab(container) {
  const tabTitles = dom.querySelectorAll(".tab-header .tab--title", container);
  const promotionBlocks = dom.querySelectorAll(".tab-block", container);

  tabTitles.forEach((tabTitle, index) => {
    dom.addEventListener(tabTitle, "click", (event) => handleTabClick(event, tabTitle, index, container, promotionBlocks));
  });
}

function handleTabClick(event, tabTitle, index, container, promotionBlocks) {
  const parentElement = tabTitle.parentElement;
  if (parentElement && parentElement.tagName === "A" && parentElement.href && parentElement.href.includes("#")) {
    event.preventDefault();
  }

  const activeElement = dom.querySelector(".tab-header .tab--title.tab--active", container);
  if (activeElement) {
    activeElement.classList.remove("tab--active");
  }

  tabTitle.classList.add("tab--active");
  const targetTabId = tabTitle.dataset.tab;
  promotionBlocks.forEach((block, i) => {
    const shouldShow = targetTabId ? block.id === targetTabId : i === index;
    block.style.display = shouldShow ? "block" : "none";
  });
}

function initializeTabTexts(container) {
  const tabTexts = dom.querySelectorAll(".tab-text", container);
  const optionsDescriptionContainer = dom.querySelector(".options_description-container", container);
  if (tabTexts.length === 0 || !optionsDescriptionContainer) return;

  const straightCashPriceText = dom.querySelector(".straight-discount-price")?.textContent;
  const {
    symbol: currencySymbol = "$",
    code: currencyCode = "COP",
    productPrice: productActualPrice = "0",
  } = optionsDescriptionContainer.dataset;

  tabTexts.forEach((tabText) => processTabText(tabText, currencySymbol, currencyCode, straightCashPriceText || productActualPrice));
  readMoreListener();
}

function processTabText(tabText, currencySymbol, currencyCode, productActualPrice) {
  const descriptionData = tabText.getAttribute("data-description");
  const titleData = tabText.getAttribute("data-title");
  const tempDiv = createTempDiv(descriptionData);
  updateProductPrice(tempDiv, productActualPrice);

  const installementsData = tabText.getAttribute("data-installments") || JSON.stringify(["1"]);
  const sortOrder = tabText.getAttribute("data-sort-order") || "asc";
  if (installementsData && installementsData.length > 0) {
    const installmentsNumbers = JSON.parse(installementsData);
    const { selectWrapper, descriptionWrapper, finalPriceBlock } = createInstallmentElements(
      installmentsNumbers,
      tempDiv,
      currencySymbol,
      currencyCode,
      sortOrder,
    );

    tabText.innerHTML = "";
    tabText.appendChild(selectWrapper);

    const financeOptionsTitle = tabText.nextElementSibling;
    if (financeOptionsTitle && financeOptionsTitle.classList.contains("popupmain-title")) {
      tabText.appendChild(financeOptionsTitle);
    }

    const paymentLinkText = (titleData || "").trim();

    tabText.appendChild(descriptionWrapper);

    if (paymentLinkText) {
      const paymentUrlWrapper = document.createElement("a");
      paymentUrlWrapper.classList.add("description-wrapper-url");
      paymentUrlWrapper.href = "#";
      paymentUrlWrapper.target = "_self";
      paymentUrlWrapper.rel = "nofollow";
      paymentUrlWrapper.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const tabDescriptionContainer = tabText.closest(".tab--description");
        const readMoreButton = tabDescriptionContainer?.querySelector(".popupmain-read-more");
        const separator = readMoreButton?.previousElementSibling;

        descriptionWrapper.classList.add("open");
        if (readMoreButton) readMoreButton.classList.add("hide-block");
        if (separator) separator.classList.add("hide-block");
        paymentUrlWrapper.style.display = "none";
      });
      paymentUrlWrapper.textContent = paymentLinkText;
      tabText.appendChild(paymentUrlWrapper);
    }

    tabText.appendChild(finalPriceBlock);
  }
}

function createTempDiv(html) {
  const tempDiv = dom.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv;
}

function updateProductPrice(tempDiv, price) {
  const productPriceElement = dom.querySelector(".product-price", tempDiv);
  if (productPriceElement) {
    productPriceElement.textContent = price;
  }
}

function createInstallmentElements(installmentsNumbers, tempDiv, currencySymbol, currencyCode, sortOrder = "asc") {
  const selectWrapper = dom.createElement("div");
  selectWrapper.classList.add("custom-select", "custom-installments");
  const descriptionWrapper = dom.createElement("div");
  descriptionWrapper.classList.add("description-wrapper");

  const amountBlock = dom.createElement("div");
  amountBlock.classList.add("installments-amount-block");

  const amountLabel = dom.createElement("span");
  amountLabel.classList.add("installments-label");
  amountLabel.textContent = "Pagas desde";

  const selectedDisplay = dom.createElement("span");
  selectedDisplay.classList.add("selected-option-display");

  const installmentsNote = dom.createElement("span");
  installmentsNote.classList.add("installments-note");
  installmentsNote.textContent = "Valores aproximados. Sujetos a condiciones del aliado";

  amountBlock.appendChild(amountLabel);
  amountBlock.appendChild(selectedDisplay);

  const finalPriceBlock = createFinalPriceBlock();
  const installmentsBlock = dom.createElement("div");
  installmentsBlock.classList.add("installments-buttons-block");

  const installmentsLabel = dom.createElement("span");
  installmentsLabel.classList.add("installments-buttons-label");
  installmentsLabel.textContent = "Cuotas";

  const installmentsButtons = dom.createElement("div");
  installmentsButtons.classList.add("installments-buttons-inline");
  installmentsBlock.appendChild(installmentsLabel);
  installmentsBlock.appendChild(installmentsButtons);

  const currentPrice = document.querySelector(".options_description-container")?.dataset?.productActualPrice || "0";
  const totalPrice = parsePrice(currentPrice);

  const sortedInstallments = installmentsNumbers
    .map((installmentMonth) => Number(installmentMonth))
    .filter((installmentMonth) => installmentMonth > 0)
    .sort((a, b) => sortOrder === "desc" ? b - a : a - b);

  sortedInstallments.forEach((installmentMonth, index) => {
    const installmentMonthNumber = installmentMonth;
    const installmentPriceNumber = outputFormatter.format(totalPrice / installmentMonthNumber);

    const installmentButton = createInstallmentButton(installmentMonth);
    installmentButton.dataset.month = String(installmentMonth);
    installmentsButtons.appendChild(installmentButton);

    if (index === 0) {
      installmentButton.classList.add("active");
      updateInstallmentInfo(
        selectedDisplay,
        descriptionWrapper,
        tempDiv,
        installmentPriceNumber,
        installmentMonthNumber,
        installmentMonth,
        currencySymbol,
        currencyCode,
        finalPriceBlock,
      );
    }

    dom.addEventListener(installmentButton, "click", () => {
      const allButtons = installmentsButtons.querySelectorAll(".installment-btn");
      allButtons.forEach((button) => button.classList.remove("active"));
      installmentButton.classList.add("active");

      const freshProductPrice = document.querySelector(".options_description-container")?.dataset?.productActualPrice || "0";
      const freshTotalPrice = parsePrice(freshProductPrice);
      const freshMonthNumber = Number(installmentMonth);
      const freshInstallmentPrice = outputFormatter.format(freshTotalPrice / freshMonthNumber);

      updateInstallmentInfo(
        selectedDisplay,
        descriptionWrapper,
        tempDiv,
        freshInstallmentPrice,
        freshMonthNumber,
        installmentMonth,
        currencySymbol,
        currencyCode,
        finalPriceBlock,
      );
    });
  });

  selectWrapper.appendChild(amountBlock);
  selectWrapper.appendChild(installmentsNote);
  selectWrapper.appendChild(installmentsBlock);

  return { selectWrapper, descriptionWrapper, finalPriceBlock };
}

function createFinalPriceBlock() {
  const finalPriceBlock = dom.createElement("div");
  finalPriceBlock.classList.add("final-price-block");
  finalPriceBlock.innerHTML = `
        <h5>Precio Final</h5>
        <div class="final-price-info">
            <span class="installment-price"></span>/mes.
            Por <span class="installment-month"></span> meses.
        </div>
    `;
  return finalPriceBlock;
}

function updateInstallmentInfo(
  selectedDisplay,
  descriptionWrapper,
  tempDiv,
  price,
  monthNumber,
  monthText,
  currencySymbol,
  currencyCode,
  finalPriceBlock,
) {
  selectedDisplay.textContent = `${currencySymbol}${price} ${currencyCode}`;

  descriptionWrapper.innerHTML = tempDiv.innerHTML;

  const installmentMonthContent = dom.querySelector(".installment-month", descriptionWrapper);
  const installmentPriceContent = dom.querySelector(".installment-price", descriptionWrapper);

  if (installmentMonthContent) {
    installmentMonthContent.textContent = monthText;
  }
  if (installmentPriceContent) {
    installmentPriceContent.textContent = `${currencySymbol}${price} ${currencyCode}`;
  }

  updateFinalPriceBlock(finalPriceBlock, monthText, currencySymbol, price, currencyCode);
}

function updateFinalPriceBlock(finalPriceBlock, monthText, currencySymbol, price, currencyCode) {
  const finalPriceMonthContent = dom.querySelectorAll(".installment-month", finalPriceBlock);
  finalPriceMonthContent.forEach((element) => {
    element.textContent = monthText;
  });

  const finalPriceInstallmentContent = dom.querySelector(".installment-price", finalPriceBlock);
  if (finalPriceInstallmentContent) {
    finalPriceInstallmentContent.textContent = `${currencySymbol}${price} ${currencyCode}`;
  }
}

function createInstallmentButton(month) {
  const button = dom.createElement("button");
  button.type = "button";
  button.classList.add("installment-btn");
  button.textContent = month;
  return button;
}

function initializeScroll(container) {
  const scrollContainer = container.querySelector(".options-scroll-container");
  if (!scrollContainer) return;

  if (scrollContainer.dataset.scrollInitialized === "true") return;
  scrollContainer.dataset.scrollInitialized = "true";

  const leftButton = container.querySelector(".options-slide-left");
  const rightButton = container.querySelector(".options-slide-right");

  let isDown = false;
  let startX;
  let scrollLeft;

  scrollContainer.style.scrollBehavior = "smooth";

  const events = {
    mousedown: (e) => {
      isDown = true;
      scrollContainer.style.cursor = "grabbing";
      scrollContainer.style.scrollBehavior = "auto";
      startX = e.pageX - scrollContainer.offsetLeft;
      scrollLeft = scrollContainer.scrollLeft;
    },
    mouseleave: () => {
      isDown = false;
      scrollContainer.style.cursor = "grab";
      scrollContainer.style.scrollBehavior = "smooth";
    },
    mouseup: () => {
      isDown = false;
      scrollContainer.style.cursor = "grab";
      scrollContainer.style.scrollBehavior = "smooth";
    },
    mousemove: (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - scrollContainer.offsetLeft;
      const walk = (x - startX) * 2;
      scrollContainer.scrollLeft = scrollLeft - walk;
      updateButtonStates();
    },
    touchstart: (e) => {
      scrollContainer.style.scrollBehavior = "auto";
      startX = e.touches[0].pageX - scrollContainer.offsetLeft;
      scrollLeft = scrollContainer.scrollLeft;
    },
    touchend: () => {
      scrollContainer.style.scrollBehavior = "smooth";
    },
    touchmove: (e) => {
      if (e.touches.length !== 1) return;
      const x = e.touches[0].pageX - scrollContainer.offsetLeft;
      const walk = (x - startX) * 2;
      scrollContainer.scrollLeft = scrollLeft - walk;
      e.preventDefault();
      updateButtonStates();
    },
  };

  Object.entries(events).forEach(([event, handler]) => {
    scrollContainer.addEventListener(event, handler, { passive: false });
  });

  const scrollAmount = 200;

  if (leftButton) {
    leftButton.addEventListener("click", () => {
      scrollContainer.scrollBy({
        left: -scrollAmount,
        behavior: "smooth",
      });
      updateButtonStates();
    });
  }

  if (rightButton) {
    rightButton.addEventListener("click", () => {
      scrollContainer.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
      updateButtonStates();
    });
  }

  function updateButtonStates() {
    const scrollLeft = scrollContainer.scrollLeft;
    const scrollWidth = scrollContainer.scrollWidth;
    const clientWidth = scrollContainer.clientWidth;

    if (leftButton) {
      if (scrollLeft <= 0) {
        leftButton.setAttribute("disabled", "disabled");
        leftButton.classList.add("disabled");
      } else {
        leftButton.removeAttribute("disabled");
        leftButton.classList.remove("disabled");
      }
    }

    if (rightButton) {
      if (scrollLeft + clientWidth >= scrollWidth) {
        rightButton.setAttribute("disabled", "disabled");
        rightButton.classList.add("disabled");
      } else {
        rightButton.removeAttribute("disabled");
        rightButton.classList.remove("disabled");
      }
    }
  }

  updateButtonStates();

  scrollContainer.addEventListener("scroll", updateButtonStates);
}

function initializeFinancePartnerSlider(scope = document) {
  const sliderRoots = scope.matches?.(".tabs-container")
    ? [scope]
    : Array.from(scope.querySelectorAll(".tabs-container"));

  sliderRoots.forEach((sliderRoot) => {
    if (sliderRoot.dataset.financePartnerSliderInitialized === "true") return;

    const container = sliderRoot.querySelector(".options-scroll-container");
    const dots = sliderRoot.querySelectorAll(".slider-dots-container .dot");

    if (!container || dots.length === 0) return;

    sliderRoot.dataset.financePartnerSliderInitialized = "true";

    sliderRoot.querySelectorAll(".tab--title").forEach((card) => {
      card.setAttribute("draggable", "false");
      card.addEventListener("dragstart", (event) => event.preventDefault());

      const image = card.querySelector("img");
      if (image) {
        image.setAttribute("draggable", "false");
      }
    });

    let currentIndex = 0;
    let dotWindowStart = 0;
    let autoPlayInterval;
    let isAutoPlayEnabled = true;
    let isProgrammaticSelection = false;

    function getVisibleCards() {
      return Array.from(sliderRoot.querySelectorAll(".tab--title")).filter((card) => {
        return window.getComputedStyle(card).display !== "none";
      });
    }

    function getVisibleCardCount() {
      return getVisibleCards().length;
    }

    function getMaxDotWindowStart() {
      return Math.max(getVisibleCardCount() - dots.length, 0);
    }

    function renderDots() {
      const visibleCards = getVisibleCards();
      const visibleCardCount = visibleCards.length;

      if (visibleCardCount === 0) return;

      currentIndex = Math.min(Math.max(currentIndex, 0), visibleCardCount - 1);
      dotWindowStart = Math.min(dotWindowStart, getMaxDotWindowStart());
      dotWindowStart = Math.max(dotWindowStart, 0);

      dots.forEach((dot, index) => {
        const mappedIndex = Math.min(dotWindowStart + index, visibleCardCount - 1);
        dot.classList.toggle("active", mappedIndex === currentIndex);
        dot.dataset.cardIndex = String(mappedIndex);
      });
    }

    function syncWindowToCurrentIndex() {
      const visibleCardCount = getVisibleCardCount();

      if (visibleCardCount <= dots.length) {
        dotWindowStart = 0;
        return;
      }

      const lastVisibleDotIndex = dotWindowStart + dots.length - 1;

      if (currentIndex < dotWindowStart) {
        dotWindowStart = currentIndex;
      } else if (currentIndex > lastVisibleDotIndex) {
        dotWindowStart = currentIndex - dots.length + 1;
      } else if (currentIndex === lastVisibleDotIndex && dotWindowStart < getMaxDotWindowStart()) {
        dotWindowStart += 1;
      } else if (currentIndex === dotWindowStart && dotWindowStart > 0) {
        dotWindowStart -= 1;
      }

      dotWindowStart = Math.min(dotWindowStart, getMaxDotWindowStart());
      dotWindowStart = Math.max(dotWindowStart, 0);
    }

    function scrollToCard(index) {
      const visibleCards = getVisibleCards();
      const targetCard = visibleCards[index];

      if (!targetCard) return;

      const maxScrollLeft = container.scrollWidth - container.clientWidth;
      const targetScrollLeft = Math.min(
        Math.max(targetCard.offsetLeft - container.offsetLeft, 0),
        Math.max(maxScrollLeft, 0)
      );

      container.scrollTo({
        left: targetScrollLeft,
        behavior: "smooth",
      });

      isProgrammaticSelection = true;
      targetCard.click();
      isProgrammaticSelection = false;
    }

    function goToCard(index) {
      currentIndex = index;
      syncWindowToCurrentIndex();
      renderDots();
      scrollToCard(currentIndex);
    }

    function stopAutoPlay() {
      window.clearInterval(autoPlayInterval);
      autoPlayInterval = null;
    }

    function disableAutoPlay() {
      isAutoPlayEnabled = false;
      stopAutoPlay();
    }

    function enableAutoPlay() {
      isAutoPlayEnabled = true;
      startAutoPlay();
    }

    function startAutoPlay() {
      stopAutoPlay();

      if (!isAutoPlayEnabled) return;

      autoPlayInterval = window.setInterval(() => {
        const visibleCardCount = getVisibleCardCount();

        if (visibleCardCount <= 1) return;

        const nextIndex = (currentIndex + 1) % visibleCardCount;
        goToCard(nextIndex);
      }, 3000);
    }

    function restartAutoPlay() {
      startAutoPlay();
    }

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        const visibleCardCount = getVisibleCardCount();

        if (visibleCardCount === 0) return;

        let targetIndex = Number(dot.dataset.cardIndex || dotWindowStart + index);

        if (index === 0 && currentIndex === targetIndex && currentIndex > 0) {
          targetIndex = currentIndex - 1;
        } else if (index === dots.length - 1 && currentIndex === targetIndex && currentIndex < visibleCardCount - 1) {
          targetIndex = currentIndex + 1;
        }

        goToCard(Math.min(targetIndex, visibleCardCount - 1));
        disableAutoPlay();
      });
    });

    sliderRoot.querySelectorAll(".tab--title").forEach((card) => {
      card.addEventListener("click", () => {
        const visibleCards = getVisibleCards();
        const visibleIndex = visibleCards.indexOf(card);

        if (visibleIndex !== -1) {
          currentIndex = visibleIndex;
          syncWindowToCurrentIndex();
          renderDots();

          if (!isProgrammaticSelection) {
            disableAutoPlay();
          }
        }
      });
    });

    sliderRoot.querySelectorAll(".tabs-container-block").forEach((tabButton) => {
      tabButton.addEventListener("click", () => {
        window.setTimeout(() => {
          currentIndex = 0;
          dotWindowStart = 0;
          container.scrollTo({ left: 0, behavior: "smooth" });
          renderDots();
          enableAutoPlay();
        }, 0);
      });
    });

    container.addEventListener("pointerdown", stopAutoPlay, { passive: true });
    container.addEventListener("touchstart", stopAutoPlay, { passive: true });
    container.addEventListener("pointerup", restartAutoPlay, { passive: true });
    container.addEventListener("touchend", restartAutoPlay, { passive: true });

    renderDots();
    startAutoPlay();
  });
}

function initializeFinanceOptionsPopup() {
  const financeOptionsPopupButton = dom.querySelector(".financing-options-button");
  const financeOptionsNPMPopupButton = dom.querySelectorAll(".financing-options-npm-button");
  const cartFinancePopupButtons = dom.querySelectorAll('.cart-payment-blocks__link[data-modal-target="modal-net-monthly-pricing-modal"], .cart-payment-blocks__button[data-modal-target="modal-net-monthly-pricing-modal"]');
  const financeOptionsPopupOverlay = dom.querySelector(".finance-options-modal-overlay");
  const financingOptionsMain = dom.querySelector(".financing-options-main");
  const financeOptionsModalTemplate = financingOptionsMain?.querySelector(".finance-options-modal-template");
  const popUpContent = dom.querySelector(".finance-options-modal-content");
  const closeButton = dom.querySelector(".finance-modal-close");

  const hasCartButtons = cartFinancePopupButtons.length > 0;
  const hasPdpPopup = financeOptionsPopupButton && financeOptionsPopupOverlay && financingOptionsMain && financeOptionsModalTemplate && popUpContent && closeButton;

  if (!hasPdpPopup && !hasCartButtons) {
    console.warn("Finance options popup elements not found");
    return;
  }

  if (!financeOptionsPopupOverlay || !popUpContent || !closeButton) {
    console.warn("Finance options popup overlay/content not found");
    return;
  }

  // Buscar template en cualquier .financing-options-main si no se encontró en el principal
  const resolvedTemplate = financeOptionsModalTemplate
    || document.querySelector(".financing-options-main .finance-options-modal-template");

  if (hasPdpPopup) {
    dom.addEventListener(financeOptionsPopupButton, "click", openModal);
  }
  dom.addEventListener(financeOptionsPopupOverlay, "click", handleOverlayClick);
  dom.addEventListener(document, "keydown", handleEscapeKey);
  closeButton.addEventListener("click", closeModal);

  for (var i = 0, len = financeOptionsNPMPopupButton.length; i < len; i++) {
      financeOptionsNPMPopupButton[i].addEventListener('click', handlePopupTriggerClick, false);
  }

  for (var j = 0, cartLen = cartFinancePopupButtons.length; j < cartLen; j++) {
      cartFinancePopupButtons[j].addEventListener('click', handlePopupTriggerClick, false);
  }

  function handlePopupTriggerClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    openModal();
  }

  function openModal() {
    if (!resolvedTemplate) {
      console.warn("Finance options modal template not found");
      return;
    }
    popUpContent.innerHTML = resolvedTemplate.innerHTML;

    const modalFinancingRoot = popUpContent.firstElementChild;
    const popupTabBlocks = modalFinancingRoot?.querySelectorAll(".tab--description") || [];
    const popupTabTexts = modalFinancingRoot?.querySelectorAll(".tab-text") || [];
    const optionsDescriptionContainer = modalFinancingRoot?.querySelector(".options_description-container");

    if (!modalFinancingRoot || !optionsDescriptionContainer) {
      console.warn("Finance options modal content could not be created");
      return;
    }

    const {
      symbol: currencySymbol = "$",
      code: currencyCode = "COP",
      productPrice: productActualPrice = "0",
    } = optionsDescriptionContainer.dataset;

    popupTabTexts.forEach((tabText, index) => {
      processTabText(tabText, currencySymbol, currencyCode, productActualPrice);

      const tabBlock = popupTabBlocks[index];
      const customSelect = tabText.querySelector(".custom-select");
      const popupTitle = tabBlock?.querySelector(".popupmain-title");

      if (popupTitle && customSelect) {
        customSelect.insertAdjacentElement("afterend", popupTitle);
      }
    });

    financeOptionsPopupOverlay.classList.add("modal-open");
    document.body.style.overflow = "hidden";
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = "fixed";

    initializeMainTab(modalFinancingRoot);
    initializeTab(modalFinancingRoot);
    initializeScroll(modalFinancingRoot);
    initializeFinancePartnerSlider(modalFinancingRoot);
  }

  function handleOverlayClick(event) {
    if (event.target === financeOptionsPopupOverlay) {
      closeModal();
    }
  }

  function handleEscapeKey(event) {
    if (event.key === "Escape" && financeOptionsPopupOverlay.classList.contains("modal-open")) {
      closeModal();
    }
  }

  function closeModal() {
    financeOptionsPopupOverlay.classList.remove("modal-open");
    const scrollY = document.body.style.top;
    document.body.style.overflow = "";
    document.body.style.top = "";
    document.body.style.position = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  }
}

function createPopupInfoDiv(popUpInfo) {
  const popupInfoDiv = dom.createElement("div");
  popupInfoDiv.classList.add("popupinfo-main");
  const popupInfoWrapper = dom.createElement("div");
  popupInfoWrapper.classList.add("popupinfo-info-wrapper");

  popupInfoWrapper.innerHTML = popUpInfo;
  popupInfoDiv.appendChild(popupInfoWrapper);
  return popupInfoDiv;
}
function readMoreListener() {
  const readMoreButtons = document.querySelectorAll(".popupmain-read-more");

  readMoreButtons.forEach((button) => {
    const tabDescriptionContainer = button.closest(".tab--description");
    const descriptionWrapper = tabDescriptionContainer?.querySelector(".description-wrapper");
    const separator = button.previousElementSibling;

    button.classList.add("hide-block");
    if (separator) separator.classList.add("hide-block");

    if (!descriptionWrapper) {
      if (separator) separator.classList.add("hide-block");
    }
  });

  const openBankDescription = (triggerElement) => {
    const tabDescriptionContainer = triggerElement.closest(".tab--description");
    if (!tabDescriptionContainer) return;

    const descriptionWrapper = tabDescriptionContainer.querySelector(".description-wrapper");
    const readMoreButton = tabDescriptionContainer.querySelector(".popupmain-read-more");
    const separator = readMoreButton?.previousElementSibling;

    if (!descriptionWrapper) return;

    descriptionWrapper.classList.add("open");
    if (readMoreButton) readMoreButton.classList.add("hide-block");
    if (separator) separator.classList.add("hide-block");
  };

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest(".popupmain-title, .popupmain-read-more, .description-wrapper-url");
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    openBankDescription(trigger);
  });
}

function initializePaymentMethodTooltips() {
  const config = {
    modal: {
      overlay: ".payment-method-modal-overlay",
      container: ".payment-method-modal-overlay .modal-content-container",
      closeButton: ".payment-method-modal-overlay .modal-close-button",
      overlayContainer: ".payment-method-modal-overlay .modal-overlay-container",
      openClass: "modal-open"
    },
    tooltipMappings: [
      {
        buttonClass: ".payment-method-tooltip-button-zero-percent",
        dataClass: ".payment-method-tooltip-data-zero-percent",
        name: "Zero Percent Financing"
      },
      {
        buttonClass: ".payment-method-tooltip-button-straight-cash",
        dataClass: ".payment-method-tooltip-data-straight-cash",
        name: "Straight Cash Discount"
      },
      {
        buttonClass: ".payment-method-tooltip-button-main",
        dataClass: ".payment-method-tooltip-data-main",
        name: "Main Payment Method"
      }
    ],
    fallbackMessage: "No tooltip data available."
  };

  const modalElements = {
    overlay: dom.querySelector(config.modal.overlay),
    container: dom.querySelector(config.modal.container),
    closeButton: dom.querySelector(config.modal.closeButton),
    overlayContainer: dom.querySelector(config.modal.overlayContainer)
  };

  if (!modalElements.overlay || !modalElements.container) {
    console.warn("Payment method tooltip modal elements not found");
    return;
  }

  function openModal(tooltipContent) {
    modalElements.container.innerHTML = tooltipContent || config.fallbackMessage;
    modalElements.overlay.classList.add(config.modal.openClass);
  }

  function closeModal() {
    modalElements.container.innerHTML = "";
    modalElements.overlay.classList.remove(config.modal.openClass);
  }

  function handleEscapeKey(event) {
    if (event.key === "Escape" && modalElements.overlay.classList.contains(config.modal.openClass)) {
      closeModal();
    }
  }

  function initializeTooltipButtons() {
    config.tooltipMappings.forEach(mapping => {
      const buttons = dom.querySelectorAll(mapping.buttonClass);

      buttons.forEach(button => {
        dom.addEventListener(button, "click", () => {
          const tooltipData = dom.querySelector(mapping.dataClass);
          const tooltipContent = tooltipData ? tooltipData.innerHTML : config.fallbackMessage;
          openModal(tooltipContent);
        });
      });
    });
  }

  function initializeModalCloseHandlers() {
    if (modalElements.closeButton) {
      dom.addEventListener(modalElements.closeButton, "click", closeModal);
    }

    if (modalElements.overlayContainer) {
      dom.addEventListener(modalElements.overlayContainer, "click", closeModal);
    }

    dom.addEventListener(document, "keydown", handleEscapeKey);
  }

  initializeTooltipButtons();
  initializeModalCloseHandlers();
}

initializePaymentMethodTooltips();

function handlePaymentSelection() {
  const paymentOptions = document.querySelectorAll('input[name="payment_option"]');
  const hiddenInput = document.getElementById("main-selected-payment-method");
  const actualPrice = document.querySelector("#price-footer-element .js-product-price-with-care-warranty");
  const actualPriceCto = document.querySelector(".cto-cart-totals .js-product-price-with-care-warranty");
  const straightCashPrice = document.querySelector("#price-footer-element .straight-discount-price");
  const straightCashPriceCto = document.querySelector(".cto-cart-totals .straight-discount-price");
  const financeTextWrappers = document.querySelectorAll("#price-footer-element .finance-text-wrapper");
  const financeTextWrappersCto = document.querySelectorAll(".cto-cart-totals .finance-text-wrapper");

  if (!paymentOptions.length || !hiddenInput) {
    return;
  }
  paymentOptions.forEach((option) => {
    if (option.checked) {
      hiddenInput.value = option.value;
    }
    updatePriceDisplay(hiddenInput);
    updatePriceDisplayCto(hiddenInput);

    option.addEventListener("change", function () {
      hiddenInput.value = option.value;
      updatePriceDisplay(option);
      updatePriceDisplayCto(option);
    });
  });

  function updatePriceDisplay(option) {
    if (option.value === "zero_percent_financing" && financeTextWrappers.length > 0 && straightCashPrice) {
      actualPrice.style.display = "block";
      financeTextWrappers[0].style.display = "flex";

      straightCashPrice.style.display = "none";
      financeTextWrappers[1].style.display = "none";
    }

    if (option.value === "straight_cash_financing" && financeTextWrappers.length > 0 && straightCashPrice) {
      actualPrice.style.display = "none";
      financeTextWrappers[0].style.display = "none";

      straightCashPrice.style.display = "block";
      financeTextWrappers[1].style.display = "flex";
    }
  }

  function updatePriceDisplayCto(option) {
    if (option.value === "zero_percent_financing" && financeTextWrappersCto.length > 0 && actualPriceCto) {
      actualPriceCto.style.display = "block";
      financeTextWrappersCto[0].style.display = "flex";

      straightCashPriceCto.style.display = "none";
      financeTextWrappersCto[1].style.display = "none";
    }
    if (option.value === "straight_cash_financing" && financeTextWrappersCto.length > 0 && straightCashPriceCto) {
      actualPriceCto.style.display = "none";
      financeTextWrappersCto[0].style.display = "none";

      straightCashPriceCto.style.display = "block";
      financeTextWrappersCto[1].style.display = "flex";
    }
  }
}

handlePaymentSelection();

function initializePaymentSystemWithObserver() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList" && document.querySelectorAll('input[name="payment_option"]').length > 0) {
        handlePaymentSelection();
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  handlePaymentSelection();
}
$(document).ready(initializePaymentSystemWithObserver);

function updateZeroPercentFinancePrice() {
  const priceElement = document.querySelector(".js-product-price-with-care-warranty[data-price-without-currency]");
  const optionsContainer = document.querySelector(".options_description-container");

  const actualPriceWithoutCurrency = priceElement?.dataset?.priceWithoutCurrency;
  const actualPriceWithCurrency = priceElement?.dataset?.price;

  if (actualPriceWithoutCurrency && optionsContainer) {
    optionsContainer.dataset.productActualPrice = actualPriceWithoutCurrency;
    optionsContainer.dataset.productPrice = actualPriceWithCurrency;
  }
}

function updateMonthlyPricingDisplay(totalPrice) {
  const displaySpan = document.querySelector(".net-monthly-pricing--pdp .js-product-price-with-care-warranty:not([data-price-without-currency])");
  if (!displaySpan) return;
  const monthsSpan = displaySpan.querySelector("span");
  if (!monthsSpan) return;
  const months = parseInt(monthsSpan.textContent, 10);
  if (!months || !totalPrice) return;
  const pricePerMonth = outputFormatter.format(totalPrice / months);
  displaySpan.innerHTML = `$ ${pricePerMonth}/mensuales por <span>${months}</span> meses.`;
}

function applyFinancingPriceUpdate(variantPrice) {
  const optionsContainer = document.querySelector(".options_description-container");
  if (!optionsContainer || !variantPrice) return;

  const symbol = optionsContainer.dataset.symbol || "$";
  const code = optionsContainer.dataset.code || "COP";

  optionsContainer.dataset.productActualPrice = String(variantPrice);
  optionsContainer.dataset.productPrice = `${symbol} ${outputFormatter.format(variantPrice)} ${code}`;

  // Llamada directa — no depende del MutationObserver de initializePriceObserver
  document.querySelectorAll(".tab-text").forEach((tabText) => {
    recalculateInstallments(tabText, symbol, code, String(variantPrice));
  });

  updateMonthlyPricingDisplay(variantPrice);
}

function setupFinancingVariantWatcher() {
  // Mecanismo 1: pubsub — se dispara justo después de que renderProductInfo actualiza el DOM
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, (eventData) => {
      const variantPriceCents = eventData?.data?.variant?.price;
      if (variantPriceCents != null) {
        // variant.price is in cents — divide by 100 to get display price
        applyFinancingPriceUpdate(variantPriceCents / 100);
        initializePaymentMethodTooltips();
      }
    });
  }

  // Mecanismo 2: observer en #price-element, que renderProductInfo reconstruye en cada variante
  const priceContainer = document.getElementById("price-element");
  if (priceContainer) {
    let debounceTimer;
    new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const priceSpan = priceContainer.querySelector(".js-product-price-with-care-warranty[data-price-without-currency]");
        if (!priceSpan) return;
        const totalPrice = parsePrice(priceSpan.dataset.priceWithoutCurrency);
        if (totalPrice > 0) {
          applyFinancingPriceUpdate(totalPrice);
          initializePaymentMethodTooltips();
        }
      }, 150);
    }).observe(priceContainer, { childList: true, subtree: true });
  } else {
    // Fallback cuando no existe #price-element
    $(document).on("change", ".product-form__input:not(.product-form__input--trade-in) input[type=radio]", function () {
      setTimeout(() => {
        updateZeroPercentFinancePrice();
        const oc = document.querySelector(".options_description-container");
        if (oc) applyFinancingPriceUpdate(parsePrice(oc.dataset.productActualPrice));
        initializePaymentMethodTooltips();
      }, 2000);
    });
  }
}

$(document).ready(setupFinancingVariantWatcher);

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[target="_blank"]').forEach(link => {
    link.setAttribute("rel", "noopener noreferrer");
  });
});